export const PROGRESS_KEY='aldapa.neutron-invaders.v1'
export type Progress={score:number;wave:number}
export function parseProgress(raw:string|null):Progress{
 try{const p=JSON.parse(raw||'null');return{score:Number.isSafeInteger(p?.score)&&p.score>=0?Math.min(999999999,p.score):0,wave:Number.isSafeInteger(p?.wave)&&p.wave>0?Math.min(9999,p.wave):1}}catch{return{score:0,wave:1}}
}
